import apiClient  from './Client';


interface PageCountOption {
    pageId: number;
    numberOfPages: number;
    price: number;
  }
  const dummyPageOptions: PageCountOption[] = [
    {
      pageId: 1,
      numberOfPages: 40,
      price: 24.99,
    },
    {
      pageId: 2,
      numberOfPages: 60,
      price: 44.99,
    },
    {
      pageId: 3,
      numberOfPages: 80,
      price: 84.99,
    },
  ];

class PageCountPages {

  getPageCountOptions = async (): Promise<PageCountOption[]> => {
    try {
    //   const response = await apiClient.get<PageCountOption[]>('Photobook/page-options');
    //   return response.data;
    return new Promise((resolve) => {
        setTimeout(() => {
          resolve(dummyPageOptions);
        }, 1000); 
      });
    } catch (error) {
      console.error('Error fetching page options:', error);
      throw error;
    }
  };
  }
  export default new PageCountPages()
